import { useEffect } from 'react';

const FlyToCartAnimator = ({ cartRef, cartControls }) => {
  useEffect(() => {
    const flyHandler = (e) => {
      const { src, rect } = e.detail || {};
      if (!src || !rect) return;

      const img = document.createElement('img');
      img.src = src;
      img.style.position = 'fixed';
      img.style.left = `${rect.left}px`;
      img.style.top = `${rect.top}px`;
      img.style.width = `${rect.width}px`;
      img.style.height = `${rect.height}px`;
      img.style.zIndex = '9999';
      img.style.borderRadius = '0.5rem';
      img.style.pointerEvents = 'none';
      img.style.objectFit = 'cover';
      document.body.appendChild(img);

      const cartEl = cartRef.current;
      if (!cartEl) {
        img.remove();
        return;
      }

      const targetRect = cartEl.getBoundingClientRect();
      const dx = targetRect.left + targetRect.width / 2 - (rect.left + rect.width / 2);
      const dy = targetRect.top + targetRect.height / 2 - (rect.top + rect.height / 2);

      const keyframes = [
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 100}px) scale(0.5)`, opacity: 0.8, offset: 0.5 },
        { transform: `translate(${dx}px, ${dy}px) scale(0.1)`, opacity: 0 }
      ];

      const anim = img.animate(keyframes, {
        duration: 800,
        easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)'
      });

      anim.onfinish = () => {
        img.remove();
        // Trigger cart icon animation on completion
        cartControls.start({ scale: [1, 1.3, 1.1, 1], transition: { duration: 0.4, times: [0, 0.4, 0.7, 1] } });
      };
    };

    window.addEventListener('fly-to-cart', flyHandler);
    return () => {
      window.removeEventListener('fly-to-cart', flyHandler);
    };
  }, [cartRef, cartControls]);

  return null; // This component does not render anything itself
};

export default FlyToCartAnimator;